import React from 'react';

export default ({active = true}) =>{
    const iconColor = active ? "black" : "#DFDFDF";

return	(
        <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="0.11377" width="4.17722" height="3.48101" rx="1.74051" fill={iconColor}/>
            <rect x="5.68359" width="4.17722" height="3.48101" rx="1.74051" fill={iconColor}/>
            <rect x="0.11377" y="5.57031" width="4.17722" height="3.48101" rx="1.74051" fill={iconColor}/>
            <rect x="5.68359" y="5.57031" width="4.17722" height="3.48101" rx="1.74051" fill={iconColor}/>
            <rect x="0.11377" y="11.1406" width="4.17722" height="3.48101" rx="1.74051" fill={iconColor}/>
            <rect x="5.68359" y="11.1406" width="4.17722" height="3.48101" rx="1.74051" fill={iconColor}/>
            <rect x="0.11377" y="16.707" width="4.17722" height="3.48101" rx="1.74051" fill={iconColor}/>
            <rect x="5.68359" y="16.707" width="4.17722" height="3.48101" rx="1.74051" fill={iconColor}/>
            <rect x="11.2529" width="4.17722" height="3.48101" rx="1.74051" fill={iconColor}/>
            <rect x="16.8228" width="4.17722" height="3.48101" rx="1.74051" fill={iconColor}/>
            <rect x="11.2529" y="5.57031" width="4.17722" height="3.48101" rx="1.74051" fill={iconColor}/>
            <rect x="16.8228" y="5.57031" width="4.17722" height="3.48101" rx="1.74051" fill={iconColor}/>
            <rect x="11.2529" y="11.1406" width="4.17722" height="3.48101" rx="1.74051" fill={iconColor}/>
            <rect x="16.8228" y="11.1406" width="4.17722" height="3.48101" rx="1.74051" fill={iconColor}/>
            <rect x="11.2529" y="16.707" width="4.17722" height="3.48101" rx="1.74051" fill={iconColor}/>
            <rect x="16.8228" y="16.707" width="4.17722" height="3.48101" rx="1.74051" fill={iconColor}/>
        </svg>
	)
}
